import React from "react";
import "./settings.css";

export default function Settings() {
  return <div className="settings">Settings</div>;
}
